import axios from 'axios'
import jsonp from 'jsonp'

import {
  ServiceConfig,
  SgsConfig,
  Geoesbmengine,
  Map,
  DFC,
  GeoEntity,
  Quota,
  Serpool
} from './../config/app-config.js'
import querystring from 'querystring'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true

const GeoesbService = Geoesbmengine.location + '/services'
const MapService = Map.location + '/services'
const DFCService = DFC.location + '/services'
const GeoEntityService = GeoEntity.location + '/services'
const QuotaService = Quota.location + '/services'
const SerpoolService = Serpool.location + '/services'

// 仅 3010 本地 dev：登录态 current.json 直连 hebei，不走 webpack 代理
function getLoginGeoesbService () {
  if (typeof APPCONFIG !== 'undefined' && APPCONFIG.isLocalDev && APPCONFIG.loginHost) {
    return APPCONFIG.loginHost + '/geoesbmengine/services'
  }
  return GeoesbService
}

// 获取固定比例尺restMap的源数据信息
export const apiCapality = url => {
  // return axios.get(url + '.json')
  return axios.get(url)
}

// 获取地图
export const getMaps = (param) => {
  return axios.get(`${ServiceConfig.getMap}`, {
    params: param || {}
  })
}
// 设置cookie
export const setCookie = (cname, cvalue, exdays) => {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
// 获取cookie
export const getCookie = (cname) => {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
// 清除cookie
export const clearCookie = (name) => {
  this.setCookie(name, '', -1)
}
// 获取子分类
export const getSpecials = (id) => {
  return axios.get(`${ServiceConfig.catalogSpecials}.json?pkid=${id}`)
}

// 获取指定ID的专题目录信息
export const getCatalogSpecial = (id) => {
  return axios.get(`${ServiceConfig.catalogSpecial}/${id}`)
}

// 获取sfs请求
export const getSfsData = (url, param) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}?`, {
    params: param || {}
  })
}

// 发送url请求元数据
export const getMetaData = (url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}`)
}

// 获取模型列表
export const getSymbol = () => {
  return axios.get(`${ServiceConfig.Planconmanage}/sys/queryAll.json`)
}

// 上传模型
export const postSymbol = (param) => {
  return axios({
    method: 'post',
    url: `${ServiceConfig.Planconmanage}/sys/uploadArchive.json`,
    data: param
  })
}

// 导出Excel
export const getExcelExport = (param) => {
  return axios({
    method: 'post',
    data: param,
    url: `${ServiceConfig.Planconmanage}/seo/exportExl`
  })
}

// 资源目录树操作
export const getServiceList = (resID, options, option, onsucc, onfail, onerror, formattype, serviceType) => {
  var url = `${SgsConfig.GetServiceNodes}/${resID}.json`
  url += '?' + 'type=' + formattype // 目录规则
  url += '&' + 'itypes=' + option.itypes // 接口类型
  if (options) {
    var catalogInfoKey = options.catalogNodeInfo.catalogType.value
    url += '&' + 'catalogInfo=' + catalogInfoKey + ':' + options.catalogNodeInfo.catalogCode // 当前目录信息
    if (options.parentCategoryNodeInfos != null && options.parentCategoryNodeInfos.length > 0) {
      url += '&' + 'parGategoryCatalog='
      var parGategoryCatalog = ''
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey = options.parentCategoryNodeInfos[i].catalogType.value
        parGategoryCatalog += parGategoryCatalogKey + ':' + options.parentCategoryNodeInfos[i].catalogCode
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ','
        }
      }
      url += parGategoryCatalog
    }
  }

  return axios({
    method: 'get',
    url: url
  })
}

export const getCatalogNodes = (options, option, onsucc, onfail, onerror, formattype, serviceType) => {
  var url = `${SgsConfig.GetCatalogNodes}`
  url += '?' + 'type=' + formattype // 目录规则
  url += '&' + 'itypes=' + option.itypes // 接口类型
  if (options) {
    url += '&' + 'catalogInfo=' + options.catalogNodeInfo.catalogType.value + ':' + options.catalogNodeInfo.catalogCode // 当前目录信息
    if (options.parentCategoryNodeInfos != null && options.parentCategoryNodeInfos.length > 0) {
      url += '&' + 'parGategoryCatalog='
      var parGategoryCatalog = ''
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey = options.parentCategoryNodeInfos[i].catalogType.value
        parGategoryCatalog += parGategoryCatalogKey + ':' + options.parentCategoryNodeInfos[i].catalogCode
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ','
        }
      }
      url += parGategoryCatalog
    }
  }
  return axios({
    method: 'get',
    url: url
  })
}

export const getResourceNodes = (options, option, onsucc, onfail, onerror, formattype, serviceType) => {
  var url = `${SgsConfig.GetResourceNodes}`
  url += '?' + 'type=' + formattype // 目录规则
  url += '&' + 'itypes=' + option.itypes // 接口类型
  if (options) {
    url += '&' + 'catalogInfo=' + options.catalogNodeInfo.catalogType.value + ':' + options.catalogNodeInfo.catalogCode // 当前目录信息
    if (options.parentCategoryNodeInfos != null && options.parentCategoryNodeInfos.length > 0) {
      url += '&' + 'parGategoryCatalog='
      var parGategoryCatalog = ''
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey = options.parentCategoryNodeInfos[i].catalogType.value
        parGategoryCatalog += parGategoryCatalogKey + ':' + options.parentCategoryNodeInfos[i].catalogCode
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ','
        }
      }
      url += parGategoryCatalog
    }
  }
  return axios({
    method: 'get',
    url: url
  })
}
export const getCatalogFormt = () => {
  return axios.get(`${SgsConfig.GetCatalogFormt}`)
}

// 资源树查询

export const searchResource = (param) => {
  return axios.get(`${SgsConfig.SearchResource}`, {
    params: param || {}
  })
}

export const searchFullResource = (param) => {
  return axios.get(`${SgsConfig.SearchFullResource}.json?includeService=false`, {
    params: param || {}
  })
}

/*
获取资源根节点
*/
export const getRootTheme = () => {
  return axios.get(`${SgsConfig.GetRootTheme}`)
}

export const getChildTheme = (id) => {
  return axios.get(`${SgsConfig.GetChildTheme}/${id}.json?datacount=true`)
}

export const apiGetUserInfo = () => {
  return axios.get(`${getLoginGeoesbService()}/servicemanager/user/current.json`)
}

export const apiBaseMap = (id) => {
  return new Promise((resolve, reject) => {
    jsonp(`${MapService}/map/manager/query.jsonp?pageindex=1&pageSize=1000&userid=${id}`, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}

export const apiAddBaseMap = (param) => {
  return axios({
    method: 'post',
    url: `${MapService}/map/manager/add.jsonp`,
    data: param
  })
}

export const updateBaseMap = (param) => {
  return axios({
    method: 'put',
    url: `${MapService}/map/manager/update.jsonp`,
    data: param
  })
}

export const apiDeleteBaseMap = (param) => {
  return axios({
    method: 'delete',
    url: `${MapService}/map/manager/remove/` + param + `.jsonp`
  })
}

// 按资源ID查询服务
export const apiServiceCatalogByResID = (id) => {
  return axios.get(`${GeoesbService}/resource/serinfo/interfaces/${id}.json`, {
    showall: false
  })
}

// 查询服务时间
export const apiServiceCatalogVersionByID = (id, key) => {
  return axios.get(`${GeoesbService}/resource/serinfo/versions/${id}/${key}.json`, {
    showall: false
  })
}

// 查询资源下所有服务
export const apiServiceCatalogServiceByID = (function () {
  let _promiseCache = {}
  return function (id) {
    if (!_promiseCache[id]) {
      _promiseCache[id] = axios.get(`${GeoesbService}/resource/data/serinfo/${id}.json`, {
        flag: 1
      })
    }
    return _promiseCache[id]
  }
}())

export const apiWMTSCapality = (param) => {
  return axios.get(`${GeoesbService}/servicanalysis/WMTS100/capality.json`, {
    params: param || {}
  })
}

export const apiServiceMetadata = (function () {
  let _promiseCache = {}
  return function (serviceId) {
    if (!_promiseCache[serviceId]) {
      _promiseCache[serviceId] = axios.get(`${GeoesbService}/resource/metadata/serinfo/${serviceId}.xml`)
    }
    return _promiseCache[serviceId]
  }
}())

export const apiResourceMetadata = (function () {
  let _promiseCache = {}
  return function (resourceId) {
    if (!_promiseCache[resourceId]) {
      _promiseCache[resourceId] = axios.get(`${GeoesbService}/resource/metadata/resinfo/${resourceId}.xml`)
    }
    return _promiseCache[resourceId]
  }
}())

export const apiBufferService = (param) => {
  param = Object.assign({
    endType: 'ROUND',
    leftDistance: 5,
    rightDistance: 5,
    type: 'geojson',
    semicircleLineSegment: 10
  }, param)
  // return axios.post(`${ServiceConfig.httpproxy}?url=${DFCService}/analyst/buffer.json?`, { data: JSON.stringify(param) });
  return axios({
    method: 'post',
    url: `${ServiceConfig.httpproxy}?url=${DFCService}/analyst/buffer.json`,
    data: JSON.stringify(param)
  })
}

// 地名地址匹配
export const fuzzyAddress = (param, url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=` + url + '?', {
    params: param || {}
  })
}

// 获取空间信息
export const getDistrict = (code) => {
  return axios.get(`${GeoEntityService}/district/${code}.json`)
}

// 获取下级区划目录
export const getChildDistrict = (param) => {
  return axios.get(`${GeoEntityService}/district/entity.json`,
    { params: param || {}})
}

// 设置地图显示范围
export const updateMap = (param) => {
  return axios.put(`${MapService}/map/manager/update.jsonp`,
    param)
}

export const apiServiceOriginUrl = (id) => {
  return axios.get(`${GeoesbService}/service/originUrl/${id}.json`)
}

export const apiScenesList = (sceneUrl) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${sceneUrl}/scenes.json`)
}

export const apiProxyUrl = (url, params) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}`, {
    params: params || {}
  })
}
// 获取模块
export const getModules = (url) => {
  return axios.get(`${GeoesbService}/${url}`)
}

export const apicurStyle = () => {
  return axios.get(`${GeoesbService}/customstyle/style/cur.json`)
}
// 地图定制相关接口
export const addStyleLayer = (param) => {
  return axios.post(TDTConfig.StyleLayer, param)
}
export const updateStyleLayer = (param) => {
  return axios.put(TDTConfig.StyleLayer, param)
}
export const getThemeByServiceId = (id) => {
  return axios.get(TDTConfig.getStyleLayer + '/' + id)
}
export const getThemesByServiceIds = (serviceList) => { // 根据服务数组查询多个专题图层
  let promiseAll = serviceList.map(function (service) {
    return axios.get(TDTConfig.getStyleLayer + '/' + service.id)
  })
  return axios.all(promiseAll)
}
export const addStyleMap = (param) => {
  return axios.post(TDTConfig.StyleMap, param)
}
export const updateStyleMap = (param) => {
  return axios.put(TDTConfig.StyleMap, param)
}
export const getStyleMapById = (id) => {
  return axios.get(TDTConfig.StyleMap + '/' + id)
}
export const getStyleMap = (param) => {
  return axios.post(TDTConfig.StyleMap + '/list', param)
}
export const deleteStyleMap = (id) => {
  return axios.delete(TDTConfig.StyleMap + '/' + id)
}
export const getSfsData_ = (url, param) => {
  return axios.get(url + '?', {params: param})
}
export const deleteSettle = (pkid) => {
  return axios.delete(TDTConfig.StyleLayer + '/' + pkid)
}
/**
 * 根据用户ID获取消息 （定时请求，2s一次）
 * @param userId
 * @returns {AxiosPromise<T>}
 */
export const getUserMessage = () => {
  return axios.get(`${GeoesbService}/messages.json?pagesize=1&pageindex=1&status=0`)
}

/**
 * 根据数据源ID获取所有的数据集信息
 * @param param
 * @returns {AxiosPromise<T>}
 */
export const getDatasetsByDatasourceId = (param) => {
  return axios.get(`${SgsConfig.getDatasetsByDataSourceId}`, {
    params: param || {}
  })
}

export const serachDatasetInfoByName = (param) => {
  return axios.get(`${SgsConfig.getDatasetInfoByDatasetName}`, {
    params: param || {}
  })
}

/**
 * 获取实体目录根节点
 */
export const apiGetEntityRoot = () => {
  return axios.get(`${GeoesbService}/servicemanager/datacatalog/tree/ENTITY.json`)
}

export const apiGetEntityRelation = (id) => {
  return apiProxyUrl(`${SerpoolService}/service/reldataset.json?datasetid=${id}`)
}

export const getTileFeature = (url, param) => {
  return axios.get(url + '/tileFeature.rjson?', {
    params: param || {}
  })
}

// 获取多个服务ID的服务
export const apiGetServiceByIds = (param) => {
  return axios.get(`${GeoesbService}/service/getServiceByIds.json`, {
    params: param || {}
  })
}

export const apiGetResourceRel = (function () {
  let _promiseCache = {}
  return function (resourceId, cache) {
    if (!cache) {
      return axios.get(`${GeoesbService}/resourcerel/getresourcerel/${resourceId}.json`)
    }
    if (!_promiseCache[resourceId]) {
      _promiseCache[resourceId] = axios.get(`${GeoesbService}/resourcerel/getresourcerel/${resourceId}.json`)
    }
    return _promiseCache[resourceId]
  }
}())

export const apiUpdateResouceRel = (params) => {
  return axios({
    method: 'put',
    url: `${GeoesbService}/resourcerel.json`,
    data: params || {}
  })
}

export const apiAddResouceRel = (params) => {
  return axios({
    method: 'post',
    url: `${GeoesbService}/resourcerel.json`,
    data: params || {}
  })
}

export const apiDeleteResourceRel = (id) => {
  return axios({
    method: 'delete',
    url: `${GeoesbService}/resourcerel/${id}.json`
  })
}

export const apiGetQutoaServiceRel = (function () {
  let _promiseCache = {}
  return function (id) {
    if (!_promiseCache[id]) {
      _promiseCache[id] = axios.get(`${QuotaService}/indicator/${id}/relinfo.json`)
    }
    return _promiseCache[id]
  }
}())



// WEBPACK FOOTER //
// ./src/apis/api.js